const resp = {
  instructions_va: [
    {
      id: "MBanking",
      title: "Petunjuk Transfer Melalui M banking",
      intruction: [
        {
          id: "1",
          idlevel1: "MBanking",
          title: "Akses dan masuk ke aplikasi internet banking",
        },
        {
          id: "2",
          idlevel1: "MBanking",
          title: "Pilih Transfer Bank",
        },
        { id: "3", idlevel1: "MBanking", title: "Pilih bank tujuan" },
        {
          id: "4",
          idlevel1: "MBanking",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "5",
          idlevel1: "MBanking",
          title:
            "Platform Internet Banking akan menampilkan informasi tentang transfer, termasuk nomor VA tujuan dan jumlah yang akan ditransfer. Pastikan semua informasi benar sebelum melanjutkan.",
        },
        {
          id: "6",
          idlevel1: "MBanking",
          title:
            "Pilih metode transfer : Transfer online atau BI-Fast, catatan : Jika nomor VA tujuan tidak bisa menggunakan BI-Fast, pilih lah metode Transfer Online",
        },
        {
          id: "7",
          idlevel1: "MBanking",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
    {
      id: "ATM",
      title: "Petunjuk Transfer Melalui ATM",
      intruction: [
        {
          id: "1",
          idlevel1: "ATM",
          title: "Masukkan kartu ATM ke mesin ATM",
        },
        {
          id: "2",
          idlevel1: "ATM",
          title: "Pilih Bahasa",
        },
        { id: "3", idlevel1: "ATM", title: " Pilih rekening asal" },
        {
          id: "4",
          idlevel1: "ATM",
          title: `Pilih opsi "Ke Rekening BRI" pada pilihan jenis transfer`,
        },
        {
          id: "5",
          idlevel1: "ATM",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "6",
          idlevel1: "ATM",
          title:
            "Mesin ATM akan menampilkan informasi tentang pembayaran, termasuk nomor VA Fixed Payment dan jumlah yang akan dibayarkan. Pastikan informasi ini benar sebelum melanjutkan.",
        },
        {
          id: "7",
          idlevel1: "ATM",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
    {
      id: "internet",
      title: "Petunjuk Transfer Melalui I Banking",
      intruction: [
        {
          id: "1",
          idlevel1: "internet",
          title: "Akses dan masuk ke aplikasi internet banking",
        },
        {
          id: "2",
          idlevel1: "internet",
          title: "Pilih menu Transfer atau Transaksi",
        },
        { id: "3", idlevel1: "internet", title: "Pilih rekening asal" },
        {
          id: "4",
          idlevel1: "internet",
          title: `Pilih tujuan transfer ke virtual account`,
        },
        {
          id: "5",
          idlevel1: "internet",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "6",
          idlevel1: "internet",
          title:
            "Platform Internet Banking akan menampilkan informasi tentang transfer, termasuk nomor VA tujuan dan jumlah yang akan ditransfer. Pastikan semua informasi benar sebelum melanjutkan.",
        },
        {
          id: "7",
          idlevel1: "internet",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
  ],
  instructions_va: [
    {
      id: "mBanking",
      title: "Petunjuk Transfer Melalui M banking",
      intruction: [
        {
          id: "1",
          idlevel1: "mBanking",
          title: "Akses dan masuk ke aplikasi internet banking",
        },
        {
          id: "2",
          idlevel1: "mBanking",
          title: "Pilih Transfer Bank",
        },
        { id: "3", idlevel1: "mBanking", title: "Pilih bank tujuan" },
        {
          id: "4",
          idlevel1: "mBanking",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "5",
          idlevel1: "mBanking",
          title:
            "Platform Internet Banking akan menampilkan informasi tentang transfer, termasuk nomor VA tujuan dan jumlah yang akan ditransfer. Pastikan semua informasi benar sebelum melanjutkan.",
        },
        {
          id: "6",
          idlevel1: "mBanking",
          title:
            "Pilih metode transfer : Transfer online atau BI-Fast, catatan : Jika nomor VA tujuan tidak bisa menggunakan BI-Fast, pilih lah metode Transfer Online",
        },
        {
          id: "7",
          idlevel1: "mBanking",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
    {
      id: "ATM",
      title: "Petunjuk Transfer Melalui ATM",
      intruction: [
        {
          id: "1",
          idlevel1: "ATM",
          title: "Masukkan kartu ATM ke mesin ATM",
        },
        {
          id: "2",
          idlevel1: "ATM",
          title: "Pilih Bahasa",
        },
        { id: "3", idlevel1: "ATM", title: " Pilih rekening asal" },
        {
          id: "4",
          idlevel1: "ATM",
          title: `Pilih opsi "Ke Rekening BRI" pada pilihan jenis transfer`,
        },
        {
          id: "5",
          idlevel1: "ATM",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "6",
          idlevel1: "ATM",
          title:
            "Mesin ATM akan menampilkan informasi tentang pembayaran, termasuk nomor VA Fixed Payment dan jumlah yang akan dibayarkan. Pastikan informasi ini benar sebelum melanjutkan.",
        },
        {
          id: "7",
          idlevel1: "ATM",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
    {
      id: "internet",
      title: "Petunjuk Transfer Melalui I Banking",
      intruction: [
        {
          id: "1",
          idlevel1: "internet",
          title: "Akses dan masuk ke aplikasi internet banking",
        },
        {
          id: "2",
          idlevel1: "internet",
          title: "Pilih Transfer Bank",
        },
        { id: "3", idlevel1: "internet", title: "Pilih bank tujuan" },
        {
          id: "4",
          idlevel1: "internet",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "5",
          idlevel1: "internet",
          title:
            "Platform Internet Banking akan menampilkan informasi tentang transfer, termasuk nomor VA tujuan dan jumlah yang akan ditransfer. Pastikan semua informasi benar sebelum melanjutkan.",
        },
        {
          id: "6",
          idlevel1: "internet",
          title:
            "Pilih metode transfer : Transfer online atau BI-Fast, catatan : Jika nomor VA tujuan tidak bisa menggunakan BI-Fast, pilih lah metode Transfer Online",
        },
        {
          id: "7",
          idlevel1: "internet",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
  ],
  instructions_va_BSI: [
    {
      id: "MBanking",
      title: "Petunjuk Transfer Melalui M banking",
      intruction: [
        {
          id: "1",
          idlevel1: "MBanking",
          title: "Akses dan masuk ke aplikasi internet banking",
        },
        {
          id: "2",
          idlevel1: "MBanking",
          title: "Pilih Transfer Bank",
        },
        { id: "3", idlevel1: "MBanking", title: "Pilih bank tujuan" },
        {
          id: "4",
          idlevel1: "MBanking",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "5",
          idlevel1: "MBanking",
          title:
            "Platform Internet Banking akan menampilkan informasi tentang transfer, termasuk nomor VA tujuan dan jumlah yang akan ditransfer. Pastikan semua informasi benar sebelum melanjutkan.",
        },
        {
          id: "6",
          idlevel1: "MBanking",
          title:
            "Pilih metode transfer : Transfer online atau BI-Fast, catatan : Jika nomor VA tujuan tidak bisa menggunakan BI-Fast, pilih lah metode Transfer Online",
        },
        {
          id: "7",
          idlevel1: "MBanking",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
    {
      id: "ATM",
      title: "Petunjuk Transfer Melalui ATM",
      intruction: [
        {
          id: "1",
          idlevel1: "ATM",
          title: "Masukkan kartu ATM ke mesin ATM",
        },
        {
          id: "2",
          idlevel1: "ATM",
          title: "Pilih Bahasa",
        },
        { id: "3", idlevel1: "ATM", title: " Pilih rekening asal" },
        {
          id: "4",
          idlevel1: "ATM",
          title: `Pilih opsi "Ke Rekening BRI" pada pilihan jenis transfer`,
        },
        {
          id: "5",
          idlevel1: "ATM",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "6",
          idlevel1: "ATM",
          title:
            "Mesin ATM akan menampilkan informasi tentang pembayaran, termasuk nomor VA Fixed Payment dan jumlah yang akan dibayarkan. Pastikan informasi ini benar sebelum melanjutkan.",
        },
        {
          id: "7",
          idlevel1: "ATM",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
    {
      id: "internet",
      title: "Petunjuk Transfer Melalui I Banking",
      intruction: [
        {
          id: "1",
          idlevel1: "internet",
          title: "Akses dan masuk ke aplikasi internet banking",
        },
        {
          id: "2",
          idlevel1: "internet",
          title: "Pilih Transfer Bank",
        },
        { id: "3", idlevel1: "internet", title: "Pilih bank tujuan" },
        {
          id: "4",
          idlevel1: "internet",
          title: "Masukkan nomor virtual account {get_VA}",
        },
        {
          id: "5",
          idlevel1: "internet",
          title:
            "Platform Internet Banking akan menampilkan informasi tentang transfer, termasuk nomor VA tujuan dan jumlah yang akan ditransfer. Pastikan semua informasi benar sebelum melanjutkan.",
        },
        {
          id: "6",
          idlevel1: "internet",
          title:
            "Pilih metode transfer : Transfer online atau BI-Fast, catatan : Jika nomor VA tujuan tidak bisa menggunakan BI-Fast, pilih lah metode Transfer Online",
        },
        {
          id: "7",
          idlevel1: "internet",
          title: "Konfirmasi transaksi.",
        },
      ],
    },
    {
      id: "bankLain",
      title: "Petunjuk Transfer Melalui Bank Lain",
      intruction: [
        {
          id: "1",
          idlevel1: "bankLain",
          title: "Akses aplikasi mobile banking bank lain dan login menggunakan akun Anda.",
        },
        {
          id: "2",
          idlevel1: "bankLain",
          title: "Pilih menu Transfer (TF).",
        },
        {
          id: "3",
          idlevel1: "bankLain",
          title: "Pilih Transfer Bank Lain.",
        },
        {
          id: "4",
          idlevel1: "bankLain",
          title: "Pilih bank tujuan BSI (Bank Syariah Indonesia).",
        },
        {
          id: "5",
          idlevel1: "bankLain",
          title: "Masukkan nomor Virtual Account (VA) {get_VA_BANKLAIN} pada kolom nomor rekening tujuan.",
        },
        {
          id: "6",
          idlevel1: "bankLain",
          title:
            "Periksa detail transfer yang ditampilkan, termasuk nama penerima dan nominal yang akan dikirim. Pastikan semua informasi sudah benar.",
        },
        {
          id: "7",
          idlevel1: "bankLain",
          title: "Pilih metode transfer online.",
        },
        {
          id: "8",
          idlevel1: "bankLain",
          title: "Masukkan nominal transfer sesuai kebutuhan.",
        },
        {
          id: "9",
          idlevel1: "bankLain",
          title:
            "Konfirmasi transaksi dengan memasukkan PIN/OTP. Simpan bukti transfer sebagai referensi.",
        },
      ],
    },
  ],
  instructions_va_BSI_POLTEKAPP: [
    {
      id: "MBanking",
      title: "Petunjuk Transfer Melalui M banking",
      intruction: [
        {
          id: "1",
          idlevel1: "MBanking",
          title: "Login BYOND by BSI.",
        },
        {
          id: "2",
          idlevel1: "MBanking",
          title: "Pilih menu Bayar/Beli.",
        },
        {
          id: "3",
          idlevel1: "MBanking",
          title: "Pilih menu Akademik.",
        },
        {
          id: "4",
          idlevel1: "MBanking",
          title: `Masukkan kode biller "2045" atau ketik nama biller "Politeknik APP Jakarta".`,
        },
        {
          id: "5",
          idlevel1: "MBanking",
          title: "Masukkan nomor bayar {get_VA}.",
        },
        {
          id: "6",
          idlevel1: "MBanking",
          title: "Layar validasi tagihan akan muncul.",
        },
        {
          id: "7",
          idlevel1: "MBanking",
          title: "Klik konfirmasi dan input PIN Anda.",
        },
        {
          id: "8",
          idlevel1: "MBanking",
          title: "Alhamdulillah, pembayaran Anda berhasil.",
        },
      ],
    },
    {
      id: "ATM",
      title: "Petunjuk Transfer Melalui ATM BSI",
      intruction: [
        {
          id: "1",
          idlevel1: "ATM",
          title: "Masukkan kartu debit Anda.",
        },
        {
          id: "2",
          idlevel1: "ATM",
          title: "Input PIN ATM Anda.",
        },
        { 
          id: "3", 
          idlevel1: "ATM", 
          title: "Pilih Tarik Tunai/Transaksi Lainnya." 
        },
        {
          id: "4",
          idlevel1: "ATM",
          title: "Pilih Menu Utama.",
        },
        {
          id: "5",
          idlevel1: "ATM",
          title: "Pilih Bayar & Beli.",
        },
        {
          id: "6",
          idlevel1: "ATM",
          title: "Pilih Akademik/Institusi.",
        },
        {
          id: "7",
          idlevel1: "ATM",
          title: "Masukkan kode pembayaran dengan ketik 2045{get_VA}",
        },
        {
          id: "8",
          idlevel1: "ATM",
          title: "Pilih “Selanjutnya” untuk konfirmasi.",
        },
        {
          id: "9",
          idlevel1: "ATM",
          title: "Alhamdulillah, pembayaran Anda berhasil.",
        },
      ],
    },
    {
      id: "internet",
      title: "Petunjuk Transfer Melalui BSI Net Banking",
      intruction: [
        {
          id: "1",
          idlevel1: "internet",
          title: "Login BSI Net Banking.",
        },
        {
          id: "2",
          idlevel1: "internet",
          title: "Pilih menu Pembayaran.",
        },
        { 
          id: "3", 
          idlevel1: "internet", 
          title: "Pilih Institusi.", 
        },
        {
          id: "4",
          idlevel1: "internet",
          title: `Pilih nama biller "Politeknik APP Jakarta".`,
        },
        {
          id: "5",
          idlevel1: "internet",
          title: "Masukkan {get_VA}",
        },
        {
          id: "6",
          idlevel1: "internet",
          title: "Kemudian akan muncul layar validasi tagihan.",
        },
        {
          id: "7",
          idlevel1: "internet",
          title: "Input Nomor Token (Request SMS) dan PIN Otorisasi Anda.",
        },
        {
          id: "8",
          idlevel1: "internet",
          title: `Kemudian pilih "Selanjutnya" untuk konfirmasi.`,
        },
        {
          id: "9",
          idlevel1: "internet",
          title: "Alhamdulillah, pembayaran Anda berhasil.",
        },
      ],
    },
    {
      id: "bankLain",
      title: "Petunjuk Transfer Melalui Bank Lain",
      intruction: [
        {
          id: "1",
          idlevel1: "bankLain",
          title: "Akses aplikasi mobile banking bank lain dan login menggunakan akun Anda.",
        },
        {
          id: "2",
          idlevel1: "bankLain",
          title: "Pilih menu Transfer (TF).",
        },
        {
          id: "3",
          idlevel1: "bankLain",
          title: "Pilih Transfer Bank Lain.",
        },
        {
          id: "4",
          idlevel1: "bankLain",
          title: "Pilih bank tujuan BSI (Bank Syariah Indonesia).",
        },
        {
          id: "5",
          idlevel1: "bankLain",
          title: "Masukkan nomor Virtual Account (VA) {get_VA_BANKLAIN} pada kolom nomor rekening tujuan.",
        },
        {
          id: "6",
          idlevel1: "bankLain",
          title:
            "Periksa detail transfer yang ditampilkan, termasuk nama penerima dan nominal yang akan dikirim. Pastikan semua informasi sudah benar.",
        },
        {
          id: "7",
          idlevel1: "bankLain",
          title: "Pilih metode transfer online.",
        },
        {
          id: "8",
          idlevel1: "bankLain",
          title: "Masukkan nominal transfer sesuai kebutuhan.",
        },
        {
          id: "9",
          idlevel1: "bankLain",
          title:
            "Konfirmasi transaksi dengan memasukkan PIN/OTP. Simpan bukti transfer sebagai referensi.",
        },
      ],
    },
    {
      id: "teller",
      title: "Petunjuk Transfer Melalui Teller Cabang BSI",
      intruction: [
        {
          id: "1",
          idlevel1: "teller",
          title: "Mengisi Slip Bayar Tagihan:\n- Nomor Rekening Sumber Dana Pembayaran (jika pindah buku) atau Setor Tunai (walk-in Teller KC).\n- Nama Pemilik Tagihan.\n- Kode 2045{get_VA} dan nama biller Politeknik APP Jakarta\n- Nomor Pembayaran.\n- Nominal Tagihan Pembayaran",
        },
        {
          id: "2",
          idlevel1: "teller",
          title: "Tanda Tangan pada Slip Bayar Tagihan, kemudian menyampaikan ke petugas Teller BSI.",
        },
        {
          id: "3",
          idlevel1: "teller",
          title: "Teller akan mengonfirmasi nominal tagihan yang akan dibayar.",
        },
        {
          id: "4",
          idlevel1: "teller",
          title: "Alhamdulillah, pembayaran Anda berhasil.",
        },
      ],
    },
  ],
};

export default resp;
